import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SURVEY_TARGET_REACHED_IN_SESSION } from '../lib/instrument-info-messages'
import { surveyEntryStatusAlertSx } from '../styles/surveyEntryStyles'

/** TC-BE-23 — 5-second countdown before redirect. */
const TARGET_COUNTDOWN_SECONDS = 5

/** TC-BE-23 — target met while SP is in survey (not session timeout; see handle-survey-session-blocked). */
export function SurveySessionBlockedView() {
  const navigate = useNavigate()
  const [secondsLeft, setSecondsLeft] = useState(TARGET_COUNTDOWN_SECONDS)

  useEffect(() => {
    if (secondsLeft <= 0) {
      navigate('/', { replace: true })
      return undefined
    }
    const id = globalThis.setInterval(() => {
      setSecondsLeft((s) => s - 1)
    }, 1000)
    return () => globalThis.clearInterval(id)
  }, [secondsLeft, navigate])

  return (
    <Box
      sx={{ maxWidth: 480, mx: 'auto', p: 3 }}
      data-testid="survey-session-blocked"
      data-reason="target"
    >
      <Alert severity="info" sx={surveyEntryStatusAlertSx}>
        {SURVEY_TARGET_REACHED_IN_SESSION}
      </Alert>
      <Typography sx={{ mt: 2 }} data-testid="survey-target-countdown">
        Returning to home in {Math.max(0, secondsLeft)}s…
      </Typography>
    </Box>
  )
}
